import LabelField from '@app/components/atoms/LabelField/LabelField'
import { LOCALISE } from '@app/constant/DateTimeConstant'
import FormHelperText from '@mui/material/FormHelperText'
import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { useTranslation } from 'react-i18next'

const TimeDisplaySection = ({ register, errors, getValues, setValue }) => {
  const { t } = useTranslation()

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <LabelField required title={t('CAMPAIGN.START_DISPLAY')}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DateTimePicker
              inputFormat={LOCALISE.DATE_TIME_FORMAT}
              minDateTime={new Date()}
              name="visible_from"
              renderInput={(params) => <TextField fullWidth {...params} />}
              {...register('visible_from')}
              value={getValues('visible_from')}
              onChange={(value) => {
                setValue('visible_from', value, { shouldValidate: true, shouldDirty: true })
              }}
            />
            <FormHelperText error={!!errors.visible_from} sx={{ pl: 2 }}>
              {errors.visible_from?.message}
            </FormHelperText>
          </LocalizationProvider>
        </LabelField>
      </Grid>
      <Grid item xs={12}>
        <LabelField required title={t('CAMPAIGN.END_DISPLAY')}>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DateTimePicker
              inputFormat={LOCALISE.DATE_TIME_FORMAT}
              minDateTime={new Date()}
              name="visible_to"
              renderInput={(params) => <TextField fullWidth {...params} />}
              {...register('visible_to')}
              value={getValues('visible_to')}
              onChange={(value) => {
                setValue('visible_to', value, { shouldValidate: true, shouldDirty: true })
              }}
            />
            <FormHelperText error={!!errors.visible_to} sx={{ pl: 2 }}>
              {errors.visible_to?.message}
            </FormHelperText>
          </LocalizationProvider>
        </LabelField>
      </Grid>
    </Grid>
  )
}
export default TimeDisplaySection
